import { Injectable, Optional, SkipSelf } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Comentario } from '../../_models/comentario';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

const API_URL = environment.apiUrl;

@Injectable({providedIn: 'root'})
export class ComentariosService {
    private subject = new Subject<any>();

    private nuevoComentarioSubject = new BehaviorSubject<{targetId: number | string, tipo: string}>({targetId: 0, tipo: ''});
    nuevoComentario$ = this.nuevoComentarioSubject.asObservable();

    constructor(private httpClient: HttpClient) {
    }
    guardarComentario(modelo: { comentario: Comentario, targetID: string | number, tipo: string }, url: string = `${API_URL}/api/Comentarios/crear`) {
        return this.httpClient.post<HttpResponse<any>>(url, modelo).pipe(
          tap(() => {
            this.nuevoComentarioSubject.next({targetId: modelo.targetID, tipo: modelo.tipo});
            this.nuevoComentarioSubject.next({targetId: 0, tipo: ''});
          })
        );
    }

    getComentariosPorObjeto(objetoID, tipo) {
        const url = `${API_URL}/api/Comentarios/${objetoID}/${tipo}`;
        return this.httpClient.get<Comentario[]>(url);
    }

    marcarLeido(comentarioID) {
        const url = `${API_URL}/api/comentarios/leido`;
        return this.httpClient.post<HttpResponse<any>>(url, { comentarioID });
    }

    actualizarComentario(comentario: Comentario) {
        const url = `${API_URL}/api/comentarios/actualizar`;
        return this.httpClient.put(url, comentario);
    }

    eliminarComentario(id) {
        const url = `${API_URL}/api/comentarios/borrar`,
            model = { comentarioID: id };
        return this.httpClient.post(url, model);
    }

    setEstadoSuscripcion(model: { targetID: number | string, tipo: string, estado: boolean }) {
        const url = `${API_URL}/api/comentarios/notificar`;
        return this.httpClient.post(url, model);
    }

    actualizarCuentaComentariosObjeto(objetoID, tipo, accion, valor = 0) {
        this.subject.next({ accion, tipo, objetoID, valor});
    }

    getComentariosObservable(): Observable<any> {
        return this.subject.asObservable();
    }


    /**
     *
     * @param {Response} res
     * @returns {*}
     */
    public extractData(res: any) {
        const body = res.hasOwnProperty('items') ? res.items : res;
        return body || {};
    }
}
